// Localization config (Armenia)

import { Localization } from '../../../shared/Localization';

import ru from '../../generic/l10n/messages_ru';
import en from '../../generic/l10n/messages_en';

const localization = new Localization('default_am', ru, [ru, en]);

export default localization;
